import { IntegrateSidebarActions } from "@/components/flow/shared/Deploy/IntegrateSidebarActions";
import { IntegrateSideMenu } from "@/components/flow/shared/Deploy/IntegrateSideMenu";
import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { BuildSteps, Flows } from "@/types/flows";

export const PreviewSidebarContent = () => {
    return (
        <>
            <SidebarHeader title="How do you want to use your model?" />
            <IntegrateSideMenu />
            <IntegrateSidebarActions previousFlow={Flows.BUILD} previousStep={BuildSteps.REVIEW} />
        </>
    );
};
